import { Box, TableCell, TableRow, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import { addDays, format, isPast, isSameDay } from "date-fns";
import React from "react";

import { formatDate } from "../../../../utils/helpers";
import useFullTimeShiftsData from "../../../full-time-shifts/controllers/use-full-time-shifts-data";
const ShiftPatternSummary = ({ shiftPatterns, width = "100%" }: {
  shiftPatterns: {
    id: string;
    name: string;
    shifts?: Record<string, { start: string; end: string }[]>;
  }[];
  width?: string;
}) => {
  const { startingDay } = useFullTimeShiftsData();
  const weekDates = Array.from({ length: 7 }, (_, i) => addDays(startingDay, i));

  return (
    <Box
      sx={{
        margin: "0",
        pageBreakAfter: "avoid",
        fontFamily: "Roboto",
        fontSize: "12px",
        marginBottom: "1rem",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Table size="small" sx={{
        tableLayout: "fixed",
        borderTop: "1px solid #E5E5E5",
        borderLeft: "1px solid #E5E5E5",
        borderRight: "1px solid #E5E5E5",
        width: width,
      }}>
        <TableBody>
          {shiftPatterns.map((pattern) => (
            <TableRow key={pattern.id}>
              <TableCell sx={{
                width: "50%",
              }}>
                <Box sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  width: "100%"
                }}>
                  <Box sx={{width: "60%"}} />
                  <Box sx={{
                    width: "40%",
                    pl: 1,
                  }}><Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "rgba(0,0,0,0.87)",
                    }}
                  >{pattern.name}</Typography></Box>
                </Box>
                </TableCell>
              {weekDates.map((day, i) => {
                const shifts = pattern.shifts?.[format(day, "yyyy-MM-dd")] || [];
                return (
                  <TableCell key={i} sx={{
                    width: `${50 / weekDates.length}%`,
                    padding: "2px",
                  }}>
                    <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}>
                      <Typography sx={{
                        fontFamily: "Roboto",
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgba(0,0,0,0.87)",
                        whiteSpace: "pre-line", // To preserve line breaks
                      }}>
                        {shifts.map(s => formatDate({
                          dateStr: s.start,
                          endDateStr: s.end,
                          formatType: "MILITARY_TIME_RANGE",
                        })).join("\n")}
                      </Typography>
                    </Box>
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ShiftPatternSummary;